<template>
  <div>
    <v-icon v-if="estatus == 'B'" color="green" @click="mostrarDialogo = true">
      mdi-file-plus
    </v-icon>

    <v-icon v-else color="red" @click="mostrarDialogo = true">
      mdi-delete
    </v-icon>

    <v-dialog v-model="mostrarDialogo" max-width="450px">
      <v-card>
        <v-card-title class="d-flex justify-center">
          <h3 class="mx-3">¿Eliminar Requisicion?</h3>
        </v-card-title>

        <v-spacer />

        <v-card-text class="d-flex justify-center">
          <span class="px-2 font-weight-bold text-subtitle-1 text--primary">
            ¿ Dar de
            <span :class="[clase]">{{ mensajeAccion }}</span>
            la requisicion con folio
            <span class="mx-1" :class="[clase]">
              {{ folio }} </span
            >?</span
          >
        </v-card-text>

        <v-spacer></v-spacer>

        <div class="d-flex justify-center">
          <v-card-actions class="mx-2 my-1">
            <v-btn text class="primary" @click="mostrarDialogo = false">
              Cancelar
            </v-btn>
            <v-btn text dark class="grey darken-1" @click="cambiarEstatus">
              Cambiar
            </v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  props: ["infoRequisicion"],

  data() {
    return {
      mostrarDialogo: false,

      folio: this.infoRequisicion.FOLIO,
      estatus: this.infoRequisicion.ESTATUS,

      mensajeAccion: "",
      clase: "",
    };
  },
  computed: {
    ...mapGetters(["getURLAPI", "getUsuario", "getFechaActual"]),
  },

  methods: {
    cambiarEstatus() {
      let datosForm = new FormData();
      datosForm.append("ESTATUS", "A");
      // datosForm.append("REQUISICION_ID", this.infoRequisicion.REQUISICION_ID);
      datosForm.append("USUARIO_MODIFICACION", this.getUsuario);
      datosForm.append("FECHA_HORA_MODIFICACION", this.getFechaActual);

      axios
        .post(
          `${this.getURLAPI}/Requisiciones/bajaRequisicion/${this.infoRequisicion.REQUISICION_ID}`,
          datosForm
        )
        .then((res) => {
          this.$root.vtoast.show({
            message: res.data.MSG || "Error",
            color:
              res.data.STATUS == "OK" ? "success darken-1" : "red darken-1",
            timer: 10000,
            icon:
              res.data.STATUS == "OK"
                ? "mdi-check"
                : "mdi-alert-circle-outline",
          });
          this.$emit("actualizarTabla");
          this.mostrarDialogo = false;
        });
    },
  },

  created() {
    // COLOR DE LA CLASE A USAR Y EL MENSAJE CAMBIA DEPENDIENDO DEL ESTATUS RECIBIDO
    if (this.infoRequisicion.ESTATUS == "A" || this.infoRequisicion.ESTATUS == "P") {
      this.mensajeAccion = "baja";
      this.clase = "red--text text--darken-3";
    } else {
      this.mensajeAccion = "alta";
      this.clase = "green--text text--darken-3";
    }
  },
};
</script>

<style></style>
